import { z } from 'zod';

// a–z, 0–9 and single inner hyphens: no leading, trailing or double hyphen (PRD Detailed Business Rule 4).
export const WEB_ADDRESS_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
export const WEB_ADDRESS_MIN_LENGTH = 3;
export const WEB_ADDRESS_MAX_LENGTH = 40;

export const isWellFormedWebAddress = (value: string): boolean =>
  value.length >= WEB_ADDRESS_MIN_LENGTH && value.length <= WEB_ADDRESS_MAX_LENGTH && WEB_ADDRESS_PATTERN.test(value);

export const WebAddressPathParamsSchema = z.object({ workspaceId: z.uuid() });

export const WebAddressResponseSchema = z.object({
  webAddress: z.string().nullable(),
  // Derived from the workspace name on every read. It may be malformed (a two-letter name); saving it is then refused.
  suggestion: z.string(),
  // Drives the confirmation before a saved address changes: every published link uses it.
  publishedWebExposeCount: z.number().int().nonnegative(),
});
export type WebAddressResponse = z.infer<typeof WebAddressResponseSchema>;

// The handler refuses a bad format (AC 2 needs its own code and sentence), so the boundary only bounds abuse.
export const UpdateWebAddressBodySchema = z.object({ webAddress: z.string().max(200) }).strict();
export type UpdateWebAddressBody = z.infer<typeof UpdateWebAddressBodySchema>;
